<template>
	<div class="buybox-row">
		<label class="buybox-row__label">
			{{ label }}
		</label>
		<slot />
	</div>
</template>

<script setup lang="ts">
defineProps<{
	label: string;
}>();
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.buybox-row {
	display: flex;
	align-items: stretch;
	width: 100%;

	&:last-of-type {
		margin-bottom: 16px;
	}

	&__label {
		margin: 0;
		margin-top: 1px;
		padding: 16px 4px;
		min-height: 90px;
		font-size: 14px;
		font-weight: 400;
		line-height: 100%;
		letter-spacing: 0.24px;
		text-transform: uppercase;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		writing-mode: vertical-lr;
		transform: rotate(180deg);
		color: $monetization-stream-text;
		background: $monetization-stream-bg;
	}

	&.dark {
		.buybox-row__label {
			color: $monetization-buy-text;
			background: #0a151f;
		}
	}
}
</style>
